import TickIcon from "@/common/images/icons/lockIcon.svg?react";

import "./ticks.scss";

export const PrivateTick = () => {
  return (
    <div className="private rg-tick" title="This thing is private">
      <TickIcon />
    </div>
  );
};
